import { render } from "./GlobalContactSection.vue?vue&type=template&id=39e32f24&scoped=true"
import script from "./GlobalContactSection.vue?vue&type=script&lang=js"
export * from "./GlobalContactSection.vue?vue&type=script&lang=js"

import "./GlobalContactSection.vue?vue&type=style&index=0&id=39e32f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e32f24"]])

export default __exports__